import "leaflet/dist/leaflet.css";
import { MapContainer, Marker, Popup, useMapEvents } from "react-leaflet";
import ReactLeafletGoogleLayer from "react-leaflet-google-layer";
import { getGoogleMapsKey } from "../../pages/constants";
import React, { useEffect } from "react";
import FeatureCollection from "geojson";

import EditControlFC from './EditControl';

import 'leaflet-draw/dist/leaflet.draw.css'
import 'leaflet-draw/dist/leaflet.draw-src.css'

export default function MapComponent(props) {
  useEffect(() => {
    console.log("MapComponent, props:", props);
    const geoJSONList = props.markers.map((marker, index) => {
      console.log("marker:", marker);
      return JSON.parse(marker.geoJSON)
    })
    console.log("geoJSONList:", geoJSONList);
    setGeojson(geoJSONList)
  }, [props]);
  const LocationCallback = () => {
    const map = useMapEvents({
      click(e) {
        props.onSelect(e);
      },
    });
    return null;
  };

  const _onCreate = (e) => {
    console.log('XX: onCreate', e);
    props.onSelect(e);
  };
  const [geojson, setGeojson] = React.useState({
    type: 'FeatureCollection',
    features: [],
  });

  return (
    <MapContainer
      center={[props.defaultCenter.lat, props.defaultCenter.lng]}
      zoom={props.defaultZoom}
      scrollWheelZoom={false}
      style={{ height: "80vh", width: "90wh" }}
    // onClick={(coordinate) => {
    //   console.log("in onClick, coordinate:", coordinate);
    //   props.onSelect(coordinate);
    // }}
    >
      {/* <LocationCallback /> */}
      <ReactLeafletGoogleLayer apiKey={getGoogleMapsKey()} type={"terrain"} />
      {/* {props.markers.map((marker, index) => {
        return (
          <Marker
            key={index}
            position={[marker.latitude, marker.longitude]}
            // title={marker.title}
            icon={marker.icon}
          >
            <Popup>{marker.details}</Popup>
          </Marker>
        );
      })} */}
      <EditControlFC geojson={geojson} setGeojson={setGeojson} onCreate={_onCreate} />

    </MapContainer>
  );
}
